export default {
  buttons: {
    title1: 'Recortar',
    title2: 'Cerrar',
  },
};
